import React from 'react';
import Icon from '@salesforce/design-system-react/components/icon';

const MetricCard = ({ title, value, format, change, trend, icon, iconCategory = 'utility', onClick, selected }) => (
  <div
    onClick={onClick}
    style={{
      backgroundColor: 'white',
      border: selected ? '2px solid #0176d3' : '1px solid #dddbda',
      borderRadius: '4px',
      padding: '20px',
      position: 'relative',
      cursor: onClick ? 'pointer' : 'default',
      transition: 'border-color 0.2s, box-shadow 0.2s',
      boxShadow: selected ? '0 0 0 1px #0176d3' : 'none',
    }}
  >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
          {icon && <Icon category={iconCategory} name={icon} size="x-small" style={{ fill: '#706e6b' }} />}
          <h3 style={{ color: '#706e6b', fontSize: '13px', margin: 0, fontWeight: '400', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            {title}
          </h3>
        </div>
        <div style={{ fontSize: '32px', fontWeight: '300', marginBottom: '8px', color: '#080707' }}>
          {format === 'currency' && '$'}
          {typeof value === 'number'
            ? value.toLocaleString('en-US', {
                minimumFractionDigits: format === 'currency' ? 0 : 0,
                maximumFractionDigits: format === 'currency' ? 0 : (format === 'percent' ? 1 : 0),
              })
            : value}
          {format === 'percent' && '%'}
        </div>
        {change !== undefined && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Icon
              category="utility"
              name={change >= 0 ? 'up' : 'down'}
              size="xx-small"
              style={{ fill: (trend === 'inverse' ? change <= 0 : change >= 0) ? '#2e844a' : '#ea001e' }}
            />
            <span style={{
              fontSize: '13px',
              color: (trend === 'inverse' ? change <= 0 : change >= 0) ? '#2e844a' : '#ea001e',
              fontWeight: 'bold',
            }}>
              {Math.abs(change)}%
            </span>
            <span style={{ fontSize: '12px', color: '#706e6b' }}>vs prior period</span>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default MetricCard;
